// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipments-shown[data-v-3ce5f947]{grid-column:1;grid-row:2}.shipments-shown .shipments-shown__label[data-v-3ce5f947]{width:165px}.shipments-shown .shipments-shown__input[data-v-3ce5f947]{max-width:140px}@media(max-width:767px){.shipments-shown[data-v-3ce5f947]{grid-row:1}}.custom-switch[data-v-3ce5f947]{width:150px;margin-top:-5px}", ""]);
// Exports
module.exports = exports;
